module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_components-716bc91b.jpg";